"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Intl = exports.is = exports.en = exports.getForLanguage = void 0;
var i18next = __importStar(require("i18next"));
var react_i18next_1 = require("react-i18next");
var Language_1 = require("./Language");
var en_json_1 = __importDefault(require("./locales/en.json"));
var is_json_1 = __importDefault(require("./locales/is.json"));
var createOptions = function (language) {
    return {
        lng: language,
        fallbackLng: "en",
        resources: {
            en: en_json_1.default,
            is: is_json_1.default
        },
        interpolation: {
            escapeValue: false // react handles escaping for us
        },
        keySeparator: false, // We don't use key.value lookups
        debug: false,
        react: { useSuspense: true }
    };
};
i18next.default
    // .use(Backend)
    // .use(LanguageDetector)Bas
    .use(react_i18next_1.initReactI18next)
    .init(createOptions(Language_1.Language.en));
var getForLanguage = function (language) {
    // @ts-ignore
    if (language in instances)
        return instances[language];
    else {
        var instance = i18next.default.cloneInstance(createOptions(language));
        // @ts-ignore
        instances[language] = instance;
        return instance;
    }
};
exports.getForLanguage = getForLanguage;
function getLanguageCodeWithoutRegion(code) {
    return code.split("-")[0];
}
function isTheSameLanguage(left, right) {
    return (getLanguageCodeWithoutRegion(left) === getLanguageCodeWithoutRegion(right));
}
var prefixUrl = function (language, path) {
    if (language.startsWith("en")) {
        return "/".concat(path).replace("//", "/");
    }
    else {
        return "/".concat(getLanguageCodeWithoutRegion(language), "/").concat(path).replace("//", "/");
    }
};
var instances = new Map();
exports.en = (0, exports.getForLanguage)(Language_1.Language.en);
exports.is = (0, exports.getForLanguage)(Language_1.Language.is);
exports.Intl = {
    en: exports.en,
    is: exports.is,
    getForLanguage: exports.getForLanguage,
    prefixUrl: prefixUrl,
    isTheSameLanguage: isTheSameLanguage,
    getLanguageCodeWithoutRegion: getLanguageCodeWithoutRegion
};
exports.default = exports.Intl;
//# sourceMappingURL=Translation.js.map